import { SessionDialog } from "../dialogs/session-dialog";
import { C } from "../messages/methods/constants";
import { OutgoingPrackRequest } from "../messages/methods/prack";
import { OutgoingRequestDelegate, RequestOptions } from "../messages/outgoing-request";
import { NonInviteClientTransaction } from "../transactions/non-invite-client-transaction";
import { UserAgentClient } from "./user-agent-client";

/**
 * PRACK UAC.
 * @public
 */
export class PrackUserAgentClient extends UserAgentClient implements OutgoingPrackRequest {
  constructor(dialog: SessionDialog, delegate?: OutgoingRequestDelegate, options?: RequestOptions) {
    const message = dialog.createOutgoingRequestMessage(C.PRACK, options);
    super(NonInviteClientTransaction, dialog.userAgentCore, message, delegate);
    dialog.signalingStateTransition(message);
  }
}
